<template>
  <Box class="BoxSectionTemplate">
    <div class="name">
      {{ sectionTemplate.name }}
    </div>
    <div class="actions">
      <slot />
    </div>
  </Box>
</template>

<script>
export default {
  props: {
    sectionTemplate: Object,
  },
}
</script>

<style lang="scss">
.BoxSectionTemplate {
  border: 1px solid $border-color;
  color: $info-darker;
  display: inline-block;
  margin-right: $grid-unit;
  width: 100%;

  > .name {
    align-items: center;
    display: flex;
    height: 4rem;
    justify-content: center;
    width: 100%;
  }
}
</style>
